import { Grid, Typography } from '@mui/material';
// import FirmWalletDetails from '../firmWallets/firmWalletDetails'
import { AddItemButton, ToolbarButton } from '@tassat/button';
import { ActionTypes, AdminRoleId } from '@tassat/common-definitions';
import { AccountCreationForm as AccountForm } from '@tassat/forms';
import { Export } from '@tassat/icon';
import { FormModal } from '@tassat/modal';
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import {
    submitAccountForm,
    validateDdaAccount
} from 'Containers/admin/forms/helpers/accountFormFn';
import { FeaturesContext } from 'Lib/context/featuresContext';
import { exportFirmAccountData } from 'Lib/exports/firmExports';
import { useAppSelector } from 'Reducers/store/hooks';
import { getAllAccountsArray, getAllAccountsByFirmId } from 'Selectors/accounts';
import { getUserAdminRoleId } from 'Selectors/common';

import FirmAccountAgGrid from './firmAccountsAgGrid';
import FirmAccountDetails from './firmAccountsDetails';

import { IFirmWalletsProps } from '.';

export function FirmAccounts(props: IFirmWalletsProps) {
    const {
        classes,
        firm
    } = props;

    const userRole = useAppSelector(getUserAdminRoleId);
    const firmAccounts = useAppSelector((state) => getAllAccountsByFirmId(state, firm?.FirmId));
    const allAccounts = useAppSelector(getAllAccountsArray);
    const features = React.useContext(FeaturesContext);
    const [ accountFormOpen, setAccountFormOpen ] = React.useState<boolean>(false);
    const [ showClosedAccounts, setShowClosedAccounts ] = React.useState<boolean>(false);

    return (
        <>
            <Switch>
                <Route
                    exact
                    path='/admin/firms/:firmId/bdaccounts/:accountId'
                    render={props => (
                        <FirmAccountDetails {...props} />
                    )}
                />
                {/* <Route
          path="/admin/firms/:firmId/wallets/:accountId"
          exact
          render={props => (
            <FirmWalletDetails {...props} />
          )}
        /> */}
                <Route
                    path='/admin/firms/:firmId'
                    render={props => (
                        <Grid
                            className={classes.root}
                            container
                            direction='column'
                            justifyContent='flex-start'
                            spacing={0}
                            wrap='nowrap'
                        >
                            <Grid
                                alignItems='center'
                                className={classes.buttonToolbar}
                                container
                                direction='row'
                                item
                                justifyContent='flex-start'
                                spacing={0}
                                xs={12}
                            >
                                {(userRole === AdminRoleId.BANK_OPS || userRole === AdminRoleId.CLIENT_SERVICES) && !firm?.IsClosed &&
                                    <AddItemButton
                                        id='firmAddWalletButton'
                                        onClick={() => setAccountFormOpen(true)}
                                        text='New BD Account'
                                    />}
                                <Typography
                                    className={`${classes.closedWalletsButton} ${showClosedAccounts ? classes.closedWalletsFilterActive : ''}`}
                                    onClick={() => setShowClosedAccounts(!showClosedAccounts)}
                                    variant='body1'
                                >
                                    {!showClosedAccounts ? 'Show' : 'Hide'} Closed BD Accounts
                                </Typography>
                            </Grid>
                            <Grid
                                className={classes.walletsGridContainer}
                                item
                                xs={12}
                            >
                                <ToolbarButton
                                    className={classes.exportButton}
                                    Icon={Export}
                                    iconClassName={classes.exportIcon}
                                    onClick={() => exportFirmAccountData(firm?.FirmId, features)}
                                    text='Export Accounts'
                                />
                                <FirmAccountAgGrid
                                    firmId={firm.FirmId}
                                    showClosedAccounts={showClosedAccounts}
                                />
                            </Grid>
                            <FormModal
                                Form={AccountForm}
                                formProps={{
                                    actionType: ActionTypes.add,
                                    firm,
                                    firmAccounts,
                                    allAccounts,
                                    submitAccountForm,
                                    validateDdaAccount
                                }}
                                modalWidth='744px'
                                onClose={() => setAccountFormOpen(false)}
                                open={accountFormOpen}
                                title='Add New BD Account'
                            />
                        </Grid>
                    )}
                />
            </Switch>
        </>
    );
}